import {Injectable} from "@angular/core";
import {ApiService} from "../api.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TalentAvailabilityApiService {
  readonly baseURL = '/api/talent-availability';

  constructor(private apiService: ApiService) {
  }

  setAvailableToWork(obfuscatedTalentId: string): Observable<number> {
    return this.apiService.httpWrapper<number>({
      method: 'POST',
      url: `${this.baseURL}/available/${obfuscatedTalentId}`,
    });
  }

  setUnavailableToWork(obfuscatedTalentId: string): Observable<number> {
    return this.apiService.httpWrapper<number>({
      method: 'POST',
      url: `${this.baseURL}/unavailable/${obfuscatedTalentId}`,
    });
  }
}
